import { render, staticRenderFns } from "./MyBatchCooking.vue?vue&type=template&id=7f5dbdb2&scoped=true"
import script from "./MyBatchCooking.vue?vue&type=script&lang=js"
export * from "./MyBatchCooking.vue?vue&type=script&lang=js"
import style0 from "./MyBatchCooking.vue?vue&type=style&index=0&id=7f5dbdb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5dbdb2",
  null
  
)

export default component.exports